import { AppThunk } from '../../store/types';
import { getActiveGroupTargetLanguage } from '../../store/models/selectors';
import { PhraseContextEditorSelectors } from '../../store/phrase-context-editor/selectors';
import { PhraseDetailsActions } from '../../store/phrase-details/actions';
import { PhraseDetailsSelectors } from '../../store/phrase-details/selectors';
import { PhraseDetailsTabsEditorPopupSelectors } from '../../store/phrase-details-tabs-editor-popup/selectors';
import { StatLogManager } from '../../../common/stats/statLogManager';
import { LangUtil } from '../../../common/utils/lang-util';
import { EPhraseDetailsTabType } from '../../store/models/types';
import { PhraseDetailsCustomPromptService } from '../phrase-details/phraseDetailsService/phrase-details-custom-prompt-service';
import { LibGptPromptRest } from '../../../common/rest/libGptPrompt/libGptPromptRest';
import { PhraseDetailsTabsEditorPopupActions } from '../../store/phrase-details-tabs-editor-popup/actions';
import { PhraseDetailsLibPromptService } from '../phrase-details/phraseDetailsService/phrase-details-lib-prompt-service';
import { PhraseDetailsExplainService } from '../phrase-details/phraseDetailsService/phrase-details-explain-service';
import { PhraseDetailsUsageService } from '../phrase-details/phraseDetailsService/phrase-details-usage-service';

export class AIEffects {

	public static load (
		useCache: boolean,
		type: EPhraseDetailsTabType,
		id?: number,
	): AppThunk {
		return async (
			dispatch,
			getState
		) => {
			const state = getState();

			const promptsChat = PhraseDetailsSelectors.getPromptsChat(state) || [];
			const item = promptsChat.find(i =>
				i.type === type &&
				(!id || i.id === id) 
			);

			const text = item?.text || PhraseDetailsSelectors.getSelectText(state) || '';
			let context = PhraseContextEditorSelectors.getPhraseContext(state)?.fullPhrase || PhraseDetailsSelectors.getContext(state) || PhraseDetailsSelectors.getCaptionLineContext(state) || '';
			if (item?.text && context && !context.includes(text)) { // edited text not from context
				context = '';
			}
			const fromLang = PhraseDetailsSelectors.getFromLang(state);
			const toLang = PhraseDetailsSelectors.getToLang(state);
			let result;

			if (id && type === EPhraseDetailsTabType.CUSTOM_PROMPT) {
				dispatch(PhraseDetailsActions.setCustomPromptResult(id, '', true, false));
				result = await new PhraseDetailsCustomPromptService(id, text, context, fromLang?.code || '', toLang?.code || '').load(useCache);
				if (result !== undefined) {
					dispatch(PhraseDetailsActions.setCustomPromptResult(id, result, false, true));
				}
			} else if (id && type === EPhraseDetailsTabType.LIB_PROMPT) {
				dispatch(PhraseDetailsActions.setLibPromptResult(id, '', true, false));
				let libs = PhraseDetailsTabsEditorPopupSelectors.getPromptLibs(state);
				if (!libs) {
					libs = await LibGptPromptRest.getLists();
					dispatch(PhraseDetailsTabsEditorPopupActions.setPromptLibs(libs));
				}
				result = await new PhraseDetailsLibPromptService(id, text, context, fromLang?.code || '', toLang?.code || '').load(useCache);
				if (result !== undefined) {
					dispatch(PhraseDetailsActions.setLibPromptResult(id, result, false, true));
				}
			} else if (type === EPhraseDetailsTabType.EXPLAIN) {
				dispatch(PhraseDetailsActions.setExplainResult('', true, false));
				result = await new PhraseDetailsExplainService(text, context, fromLang?.code || '', toLang?.code || '').load(useCache);
				if (result !== undefined) {
					dispatch(PhraseDetailsActions.setExplainResult(result, false, true));
				}
			} else if (type === EPhraseDetailsTabType.USAGE) {
				dispatch(PhraseDetailsActions.setUsageResult('', true, false));
				result = await new PhraseDetailsUsageService(text, context, fromLang?.code || '', toLang?.code || '').load(useCache);
				if (result !== undefined) {
					dispatch(PhraseDetailsActions.setUsageResult(result, false, true));
				}
			}

			const langCode = LangUtil.checkLangCode(getActiveGroupTargetLanguage(state)?.code);
			StatLogManager.logPromptAccess(langCode);
		}
	}

}
